<div class="flex w-full">
  <span
    class="px-2 py-3 text-white"
    [ngClass]="{
      'bg-error': data.type === 'error',
      'bg-info': data.type === 'info',
      'bg-success': data.type === 'success',
      'bg-warning': data.type === 'warning'
    }"
  >
    <ng-container [ngSwitch]="data.type">
      <app-icon *ngSwitchCase="'error'" name="error" class="text-white"></app-icon>
      <app-icon *ngSwitchCase="'info'" name="info" class="text-white"></app-icon>
      <app-icon *ngSwitchCase="'success'" name="check-circle" class="text-white"></app-icon>
      <app-icon *ngSwitchCase="'warning'" name="warning"></app-icon>
    </ng-container>
  </span>
  <span
    class="flex grow flex-col gap-4 border-t-2 bg-white p-3 pr-8"
    [ngClass]="{
      'border-error': data.type === 'error',
      'border-info': data.type === 'info',
      'border-success': data.type === 'success',
      'border-warning': data.type === 'warning'
    }"
  >
    <div class="flex flex-col gap-0.5">
      <div *ngIf="data.content?.label" class="grow font-bold" ndtSnackBarLabel>{{ data.content.label }}</div>
      <p class="mb-0 font-normal">{{ data.content.message }}</p>
    </div>
    <button
      ndt-icon-button
      ndtSnackBarAction
      aria-label="Zamknij"
      i18n-aria-label
      type="button"
      class="absolute right-3 top-3 text-secondary"
      (click)="snackBarRef.dismiss()"
    >
      <app-icon name="close"></app-icon>
    </button>

    <div ndtSnackBarActions *ngIf="hasAction">
      <button
        *ngIf="data.actions.secondary"
        type="button"
        ndt-tertiary-button
        ndtSnackBarAction
        (click)="snackBarRef.dismissWithAction()"
      >
        {{ data.actions.secondary }}
      </button>
      <button
        *ngIf="data.actions.primary"
        type="button"
        ndt-tertiary-button
        ndtSnackBarAction
        (click)="snackBarRef.dismissWithAction()"
      >
        {{ data.actions.primary }}
      </button>
    </div>
  </span>
</div>
